import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '../../theme';
import { useTabListStyles } from './TabList.Styles';
import { TabList as HeadlessTabList } from '@headlessui/react';
export const TabList = ({ fullWidth, children }) => {
    const theme = useTheme();
    const styles = useTabListStyles({
        ...{ fullWidth: fullWidth ?? false },
        theme
    });
    return (_jsx(HeadlessTabList, { className: styles.tabList, children: children }));
};
